import { makeStyles } from "@material-ui/core/styles";

const useFormStyles = makeStyles(theme => ({
  formControlFlex: {
    display: "flex",
    flexDirection: "row"
  },
  root: {
    "& .MuiFormControl-root": {
      margin: theme.spacing(1),
      minWidth: 120,
      width: "100%"
    },
    "& .MuiFormLabel-root": {
      fontWeight: "bold"
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.error.main
    }
  },
  rootB: {
    "& .MuiFormControl-root": {
      margin: theme.spacing(1),
      minWidth: 120,
      width: "100%"
    },
    "& .MuiFormLabel-root": {
      fontWeight: "bold"
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.error.main
    },
    [theme.breakpoints.down("sm")]: {
      "& .MuiFormControl-root": {
        width: "100%"
      }
    }
  },
  radio: {
    "& .MuiRadio-root": {
      color: theme.palette.secondary.main
    }
  },
  select: {
    "& .MuiSelect-root": {
      color: theme.palette.secondary.main
    },
    "& .MuiSelect-icon": {
      color: theme.palette.secondary.main
    }
  },
  input: {
    "& .MuiInputBase-root": {
      color: theme.palette.secondary.main
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.error.main
    }
  },
  label: {
    "& .MuiFormLabel-root": {
      color: theme.palette.secondary.main
    }
  }
}));

export default useFormStyles;
